import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import * as fromProfilerStore from 'src/app/profiler-store';

@Component({
    selector: 'atlas-profiler-properties',
    templateUrl: './profiler-properties.component.html',
    styleUrls: ['./profiler-properties.component.less'],
    standalone: false
})
export class ProfilerPropertiesComponent implements OnInit{

  private subscription: Subscription = new Subscription();
  deletionDate: Date;

  profilerDeletionDate$ = this.store$.select(
    fromProfilerStore.getProfilerDeletionDate
  );

  constructor(private store$: Store<fromProfilerStore.State>) {}

  ngOnInit(): void {
    this.subscription.add(
      this.profilerDeletionDate$.subscribe((deletionDate) => {
        if (deletionDate) {
          this.deletionDate = deletionDate;
        }
      })
    );
  }
  
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  isCurrentDateBeforeDeleteDate() {
    return this.deletionDate > new Date();
  }

}
